import '../styles/popup.scss';
import { useState, useEffect } from 'react';

export const PopUpMessage = () => {
  const [ popUp, setPopUp ]  = useState(false);

  useEffect(() => {
    setTimeout(
      () => setPopUp(true),
      5000
    )
  }, []);

  const close = () => setPopUp(false);
 
  return (
    <>
      {popUp ?
        <div className='pop-up'>
          <div className='pop-up-box'>
            <div className='pop-up-btn'>
              <button onClick={close}>X</button>
            </div>
            <div className='img-pop-up'></div>
          </div>
        </div>
      : null}
    </>
  );
};
